<template>
	<div />
</template>

<script>
import Vue from 'vue';

export default {
	name: 'Cordova',
	data() {
		return {
			instance: null,
			device: null,
			network: true
		};
	},
	computed: {
		env() {
			return this.$settings.env;
		},
		online() {
			return this.$gestios.connected;
		}
	},
	watch: {
		network(value) {
			if (value) {
				this.$router.back();
			} else {
				this.$router.push({ name: '_offline' });
			}
		},
		env(value) {
			this.statusbar(value);
		},
		online() {
			this.analytics();
		}
	},
	created() {
		Vue.prototype.$cordova = this;

		document.addEventListener('deviceready', () => {
			this.device = device.platform;
			this.instance = window.cordova;

			// Check network status
			this.networkCheck();

			// Instance Firebase Plugins
			this.firebase();

			// Hide splashscreen
			navigator.splashscreen.hide();
		},
		false);
	},
	methods: {
		networkCheck() {
			if (this.instance) {
				if (navigator.connection.type === 'none') this.$router.push({ name: '_offline' });

				document.addEventListener(
					'offline',
					() => {
						this.network = false;
					},
					false
				);

				document.addEventListener(
					'online',
					() => {
						this.network = true;
					},
					false
				);
			}
		},
		firebase() {
			if (window.FirebasePlugin && this.instance) {
				// Send errors to Crashlytics
				const appRootURL = window.location.href.replace('index.html', '');
				window.onerror = function (errorMsg, url, line, col, error) {
					let logMessage = errorMsg;
					let stackTrace = null;

					const sendError = function () {
						window.FirebasePlugin.logError(logMessage, stackTrace);
					};

					logMessage += `: url=${url.replace(appRootURL, '')}; line=${line}; col=${col}`;

					if (typeof error === 'object') {
						// eslint-disable-next-line no-undef
						StackTrace.fromError(error).then((trace) => {
							stackTrace = trace;
							sendError();
						});
					} else {
						sendError();
					}
				};
			}
		},
		analytics() {
			if (window.FirebasePlugin && this.instance) {
				if (this.online) {
					window.FirebasePlugin.setAutoInitEnabled(true);
				} else {
					window.FirebasePlugin.setAutoInitEnabled(false);
				}

				// ANALYTICS
				window.FirebasePlugin.setAnalyticsCollectionEnabled(true);

				if (this.online) {
					const { user } = this.$store.getters;
					window.FirebasePlugin.setUserId(user.ID.toString());
				}
			}
		},
		statusbar(value) {
			if (this.instance) {
				if (value === 'production') {
					StatusBar.backgroundColorByHexString('#161537');
				} else {
					StatusBar.backgroundColorByHexString('#ff8200');
				}
			}
		}
	}
};
</script>
